import React from 'react';
import { arrayOf, func, shape } from 'prop-types';
import { AUITable } from '@ancert/aui-table';
import getColumns from './columns';
import { PAGE_SIZE } from '../../../../../config';
import { ROL } from '../../../../../lib/role.enum';
import { useSession } from '../../../../../context/session.context';

const DenunciaSeleccionada = ({ complaintSelected, setComplaintSelected }) => {
  const { getUser } = useSession();
  const { role } = getUser();
  const onDesasignar = (value) => {
    const aux = [...complaintSelected].filter((obj) => obj.complaint.id !== value.complaint.id);
    setComplaintSelected(aux);
  };

  return (
    <div>
      <h3 className="u-mt-32">Denuncias seleccionadas</h3>
      <AUITable
        className="u-mt-16"
        columns={getColumns(onDesasignar, [ROL.ADMINISTRADOR, ROL.RESPONSABLE].includes(role))}
        data={complaintSelected}
        forcePagination
        pageSize={PAGE_SIZE.LISTADO_DENUNCIAS_SELECCIONADAS}
      />
    </div>
  );
};
DenunciaSeleccionada.propTypes = {
  complaintSelected: arrayOf(shape({})).isRequired,
  setComplaintSelected: func.isRequired,
};
DenunciaSeleccionada.defaultProps = {};

export default DenunciaSeleccionada;
